<script setup lang="ts">
import {
  computed,
} from 'vue';
import { useRoute } from 'vue-router';

import VCard from '@components/card/VCard/VCard.vue';
import {
  AFFILIATE_PROGRAM_COMMISSIONS_LIST_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_PROGRAM_COMMISSIONS,
} from '@modules/affiliate-program-commissions/constants';
import AffiliateProgramCommissionsForm
  from '@modules/affiliate-program-commissions/submodules/edit/components/AffiliateProgramCommissionsForm/AffiliateProgramCommissionsForm.vue';
import {
  useAffiliateProgramCommissionsConstantsQuery,
  useAffiliateProgramCommissionsItemQuery,
  useAffiliateProgramCommissionsMerchantsQuery,
} from '@modules/affiliate-program-commissions/submodules/edit/queries';
import { useCountriesQuery } from '@modules/countries/queries';

const route = useRoute();

const isEdit = computed(() => !!route.params.id);
const id = computed<number | undefined>(() => (
  route.params.id ? Number(route.params.id) : undefined
));

const { data: merchantsList, isLoading: isLoadingMerchants } = useAffiliateProgramCommissionsMerchantsQuery();
const { data: constants, isLoading: isLoadingConstants } = useAffiliateProgramCommissionsConstantsQuery();
const { data: countries, isLoading: isLoadingCountries } = useCountriesQuery();
const { data: commission, isLoading: isLoadingItem } = useAffiliateProgramCommissionsItemQuery(id);

const isLoading = computed(() => (
  isLoadingMerchants.value || isLoadingConstants.value || isLoadingCountries.value || (!!id.value && isLoadingItem.value)
));
</script>

<template>
  <VCard v-data-qa-auto-id="'AffiliateProgramCommissionsEditPage'"
    :title="$getTranslation(
      TRANSLATION_GROUP_AFFILIATE_PROGRAM_COMMISSIONS,
      isEdit ? 'HEADER_EDIT' : 'HEADER_CREATE',
    )"
    type="form"
  >
    <AffiliateProgramCommissionsForm
      :is-loading="isLoading"
      :commission="commission"
      :countries="countries"
      :constants="constants"
      :merchants-list="merchantsList"
      :is-edit="isEdit"
      :back-route-label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_PROGRAM_COMMISSIONS, 'COMMON_BUTTONS_BACK')"
      :back-route="{ name: AFFILIATE_PROGRAM_COMMISSIONS_LIST_ROUTE_NAME }"
    />
  </VCard>
</template>
